var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpCircle = function SvgArrowUpCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.751,
    height: 26.751
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow-up-circle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#013d8c",
    d: "M0 0h26.751v26.751H0z",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 2313"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 672"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#013d8c",
    clipPath: "url(#arrow-up-circle_svg__a)",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 671",
    transform: "rotate(-90 13.376 13.376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.189 17.69V9.06a2.383 2.383 0 0 1 3.813-1.907l5.753 4.315a2.383 2.383 0 0 1 0 3.813l-5.753 4.315a2.383 2.383 0 0 1-3.813-1.907",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 15355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.376 26.751a13.376 13.376 0 1 1 13.375-13.375 13.39 13.39 0 0 1-13.375 13.375m0-24.381a11.005 11.005 0 1 0 11.005 11.006A11.02 11.02 0 0 0 13.376 2.37",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 15356"
  })))));
};
export default SvgArrowUpCircle;